import { useCallback, useEffect, useState } from "react";

import { GlobalBalanceDto } from "interfaces";
import { getBalances } from "services";
import { UserStore } from "stores/UserStore";
import { SettingsStore } from "stores/SettingsStore";
import { useWebSocketNotifications } from "./useWebSocketNotifications";

// Глобальная функция для обновления баланса
let globalFetchBalance: (() => Promise<void>) | null = null;

export const setGlobalFetchBalance = (fetchBalanceFn: (() => Promise<void>) | null) => {
  globalFetchBalance = fetchBalanceFn;
};

export const getGlobalFetchBalance = () => globalFetchBalance;

export const useGlobalBalance = (user: UserStore, settings: SettingsStore) => {
  // const { isConnected } = useWebSocketNotifications();
  const [balance, setBalance] = useState<GlobalBalanceDto>();

  const fetchBalance = useCallback(async () => {
    if (user.isAuthorized) {
      await getBalances()
        .then((balances) => {
          setBalance(balances);

          settings.fetchRates();
        })
        .catch((e) => {
          console.error(e);
        });
    } else return;
  }, [user.isAuthorized]);

  // Устанавливаем глобальную функцию при создании хука
  useEffect(() => {
    setGlobalFetchBalance(fetchBalance);
    return () => {
      setGlobalFetchBalance(null);
    };
  }, [fetchBalance]);

  useEffect(() => {
    fetchBalance();
  }, [fetchBalance]);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    // if (!isConnected) {
    interval = setInterval(fetchBalance, 30000);
    // }
    return () => clearInterval(interval);
  }, [fetchBalance]);

  return balance;
};
